import React from 'react'

const findBusinessSolutions = props => {
    return (
        <div class={props.show ? "tab-pane fade show active" : "tab-pane fade"} id="pills-personal-finace" role="tabpanel" aria-labelledby="pills-personal-finace-tab">
            <div class="services_list_block">
                {/* <h3>Get Personal Finance Help</h3> */}
                <div class="row row_m8">
                    <div class="col-xl-4 col-lg-6 col-sm-6 col_p8 mx-auto">
                        <div class="card_services_link">
                            <div class="card services_card other_card finance_card">
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item"><a href="javascript:void(0)" onClick={props.showComingSoonModal}>Accounting</a></li>
                                    <li class="list-group-item"><a href="javascript:void(0)" onClick={props.showComingSoonModal}>PayRoll </a></li>
                                    <li class="list-group-item"><a href="javascript:void(0)" onClick={props.showComingSoonModal}>Income Tax</a></li>
                                    <li class="list-group-item"><a href="javascript:void(0)" onClick={props.showComingSoonModal}>Entity Structure</a></li>
                                    <li class="list-group-item"><a href="javascript:void(0)" onClick={props.showComingSoonModal}>Biz Loans + Lending</a></li>
                                    <li class="list-group-item"><a href="javascript:void(0)" onClick={props.showComingSoonModal}>Payment Solutions</a></li>
                                    <li class="list-group-item"><a href="javascript:void(0)" onClick={props.showComingSoonModal}>Marketing</a></li>
                                    <li class="list-group-item"><a href="javascript:void(0)" onClick={props.showComingSoonModal}>Insurance</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div class="empty_details notifications">
                    <div class="card">
                        <div class="card-body">
                            <div className="empty_img">
                                <img src="/images/customs/coming_soon.png" />
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default findBusinessSolutions